import moment from 'moment';
import departments from '@/data/departments';
import { filter } from 'lodash';

export default function transformFilters(filters: any) {
    // console.log("FILTERS INPUT:", {
    //     includeProfitabilityMin: filters.includeProfitabilityMin,
    //     profitabilityMin: filters.profitabilityMin,
    //     includeNoProfitability: filters.includeNoProfitability
    // });
    const {
        status,
        dateInterval,
        dateIntervalFinBail,
        budget,
        program,
        outdoors,
        taxes,
        types,
        types2,
        exposures,
        country,
        region,
        departement,
        city,
        cp,
        timeStep,
        dutyFreeFeeMin,
        includeNoDFF,
        profitabilityMin,
        includeProfitabilityMin,
        includeNoProfitability,
        surfaceInterval,
        surfaceExtInterval,
        BuildingCoteInterval,
        floorInterval,
        rez,
        type_flux,
        profitabilityProgramGtieInterval,
        promotor,
        statusProgram,
        zones,
        electronic_sign,
        commercials,
        includeFavorite,
        pinelPlus,
        isLivrable,
        isActable,
        brs
    } = filters;

  

        const regionArray = Array.isArray(region) ? region : (region ? [region] : []);
        const departmentArray = Array.isArray(departement) ? departement : (departement ? [departement] : []);

        const departmentsFromRegion = departments.filter(dept => {
            return regionArray.includes(dept.region_code);
        });
        const depOnlyCodes = departmentsFromRegion.map(dep => dep.code);

        // Merge region departments + manually selected departments, no duplicates
        const mergedDepartments = Array.from(new Set([...depOnlyCodes, ...departmentArray]));




    const minDate = date(dateInterval[0], timeStep);
    const maxDate = date(dateInterval[1], timeStep);
    const minDateIsAtMinimum = dateInterval[0] === 40;

    



    const obj: any = {
        tax_system: taxes.length > 0 ? taxes : null,
        type: types.length > 0 ? types : null,
        type2: types2.length > 0 ? types2 : null,
        exposures: exposures && exposures.length > 0 ? exposures : null,
        isLivrable: isLivrable || false,
        isActable: isActable || false,
        price: {
            min: budget.min || null,
            max: budget.max || null,
        },
        status,
        dateInterval: {
            min: minDate && filters.includeDeliveryTrimester
                ? moment()
                    .quarter(minDate)
                    .startOf('quarter')
                    .toISOString()
                : null,
            max: maxDate && filters.includeDeliveryTrimester
                ? moment()
                    .quarter(maxDate)
                    .endOf('quarter')
                    .toISOString()
                : null,

                isAtMinimumValue: filters.includeDeliveryTrimester && minDateIsAtMinimum
        },
        dateIntervalFinBail: {
            min: dateIntervalFinBail[0] !== null && filters.includeDateFinBail ? dateFinBail(dateIntervalFinBail[0]) : null,
            max: dateIntervalFinBail[1] && filters.includeDateFinBail ? dateFinBail(dateIntervalFinBail[1]) : null,
        },
        rez,
        program,
        pinelPlus,
        brs,
        outdoors,
        // on envoi la liste des départements sous forme de tableau

        country: country && country.length > 0 ? country : null,  
        // Par :
     
        departments: mergedDepartments.length > 0 ? mergedDepartments : null,
        city: Array.isArray(city) ? city : (city ? [city] : null),
        cp: Array.isArray(cp) && cp.length > 0 ? cp : null,

        promotor,
        statusProgram,
        zones: zones.length > 0 ? zones : null,
    };

    // console.log("ADDING PROFITABILITY FILTER:", {
    //     includeProfitabilityMin,
    //     profitabilityMin,
    //     includeNoProfitability
    // });
    
    if (includeProfitabilityMin) {
        // Ensure profitabilityMin is a valid number and not above 30
        if (profitabilityMin !== null && profitabilityMin !== undefined && profitabilityMin !== '') {
            // Convert to number
            const profitValue = Number(profitabilityMin);
            
            // Only apply filter if value is <= 30
            if (profitValue <= 30) {
                obj.profitabilityMin = profitValue;
                // console.log("Setting profitabilityMin filter to:", obj.profitabilityMin);
                
                if (includeNoProfitability) {
                    obj.includeNoProfitability = true;
                }
            } else {
                console.log("Profitability value exceeds maximum (30), not applying filter");
                // Ne pas définir obj.profitabilityMin du tout si > 30
            }
        }
    } else {
        // Si le filtre n'est pas activé, s'assurer que la propriété n'est pas définie
        if (obj.hasOwnProperty('profitabilityMin')) {
            delete obj.profitabilityMin;
        }
        if (obj.hasOwnProperty('includeNoProfitability')) {
            delete obj.includeNoProfitability;
        }
    }

    if(filters.dutyFreeFeeMin !== null) {
        obj.dutyFreeFeeMin = filters.dutyFreeFeeMin;
    }

    if(filters.includeFavorite !== false) {
        obj.includeFavorite = filters.includeFavorite;
    }

    if(filters.operator !== null) {
        obj.operator = filters.operator;
    }



    if (exposures && exposures.length > 0) {
        console.log("Exposures filter is active:", exposures);
    } else {
        console.log("No exposures filter active");
    }
    

    



    /*if (filters.includeDutyFree) {
        obj.dutyFreeFeeInterval = {
            min: dutyFreeFeeInterval[0],
            max: dutyFreeFeeInterval[1],
        };
    }*/

    if(filters.rez !== null) {
        obj.rez = filters.rez;
    }

    if(filters.includeNoDFF == true) {
        obj.includeNoDFF = filters.includeNoDFF;
    }

    if(filters.electronic_sign !== null) {
        obj.electronic_sign = filters.electronic_sign;
    }

    if(filters.commercials !== null) {
        obj.commercials = filters.commercials;
    }

    if (filters.includeSurface) {
        obj.surfaceInterval = {
            min: surfaceInterval[0],
            max: surfaceInterval[1],
        };
    }
    if (filters.includeBuildingCote) {
        obj.BuildingCoteInterval = {
            min: BuildingCoteInterval[0],
            max: BuildingCoteInterval[1],
        };
    }

    if (filters.includeExtSurface) {
        obj.surfaceExtInterval = {
            min: surfaceExtInterval[0],
            max: surfaceExtInterval[1],
        };
    }

    if (filters.includeFloor) {
        obj.floorInterval = {
            min: floorInterval[0],
            max: floorInterval[1],
        };
    }

    if(filters.type_flux) {
        obj.type_flux = filters.type_flux;
    }

    if (filters.includeProfitability) {
        obj.profitabilityProgramGtie = {
            min: profitabilityProgramGtieInterval[0],
            max: profitabilityProgramGtieInterval[1],
        };
    }

    if (filters.includeUsufruitDuration && filters.dureeUsufruitInterval) {
        obj.dureeUsufruitInterval = {
            min: filters.dureeUsufruitInterval[0],
            max: filters.dureeUsufruitInterval[1],
        };
    }

    
    if (filters.includeNuePro && filters.dureeNueProInterval) {
        obj.valeurNueProInterval = {
            min: filters.dureeNueProInterval[0], 
            max: filters.dureeNueProInterval[1],
        };
    }

    if (filters.includeBailDuration) {
        obj.bailDurationInterval = {
            min: filters.bailDurationInterval[0],
            max: filters.bailDurationInterval[1],
        };
    }
//     console.log("NuePro filter enabled:", filters.includeNuePro);
// console.log("NuePro values:", filters.nuePro);
// console.log("dureeNueProInterval values:", filters.dureeNueProInterval);

    if (isLivrable) {
        // When true, add a condition to select programs with a delivery date before now.
        obj.deliveryDateFilter = {
          operator: '<',
          value: moment().toISOString(),
        };
      }
      
      if (isActable) {
        // When true, add a condition to select programs with an actability date before now.
        obj.actabilityDateFilter = {
          operator: '<',
          value: moment().toISOString(),
        };
      }
    //   console.log("Final Filter Object Sent:", JSON.stringify(obj, null, 2));  // ✅ Debug log

    console.log("DEPARTMENTS SENT TO BACKEND:", obj.departments);
    return obj;
}

function date(value: number, timeStep: number) {
    value -= 40;
    const currentQuarter = moment().quarter();
    return currentQuarter + value;
}

function dateFinBail(value: number){
    var date = moment().startOf('quarter')
    const currentQuarter = moment().quarter();
    value = (value+currentQuarter-1)
    if(value !== 0){
        var quotient = Math.floor(value/4);
        var remainder = value % 4;
        date = moment().add(quotient, 'y').quarter(remainder).startOf('quarter');
    }
    return date.toISOString();
}